import {
    DollarOutlined,
    CreditCardOutlined,
    MobileOutlined,
    FileTextOutlined,
    GlobalOutlined,
} from "@ant-design/icons";

export const MODE_META = {
    CASH: {
        icon: <DollarOutlined />,
        label: "Cash",
        iconBg: "#b8860b",
        iconColor: "#fff9e0",
    },
    CARD: {
        icon: <CreditCardOutlined />,
        label: "Card",
        iconBg: "#0984b8",
        iconColor: "#d0f4ff",
    },
    UPI: {
        icon: <MobileOutlined />,
        label: "UPI",
        iconBg: "#00856a",
        iconColor: "#c8fff4",
    },
    CHEQUE: {
        icon: <FileTextOutlined />,
        label: "Cheque",
        iconBg: "#b85c00",
        iconColor: "#ffe8cc",
    },
    ONLINE: {
        icon: <GlobalOutlined />,
        label: "Online",
        iconBg: "#5a4fcf",
        iconColor: "#e8e4ff",
    },
};

export const MODE_ORDER = ["CASH", "CARD", "UPI", "CHEQUE", "ONLINE"];

/* compact display, e.g. ₹1.2L / ₹4.5k — used on the dashboard row */
export const fmt = (n) =>
    n >= 100000
        ? `₹${(n / 100000).toFixed(1)}L`
        : n >= 1000
            ? `₹${(n / 1000).toFixed(1)}k`
            : `₹${n}`;

/* full precision, e.g. ₹1,20,450.00 — used inside the transactions dialog */
export const fmtFull = (n) =>
    `₹${Number(n || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;